import React, {Component} from 'react'

export default class BankItemRow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            item: props.item,
        }
    }

    render() {
        let sumStyle = {};

        if (this.state.item.sum === this.props.selectedInvoicesSum) {
            sumStyle = {
                textDecoration: "underline",
                fontWeight: "bold"
            };
        }

        return (
            <tr key={this.state.item.id}
                className={(this.state.item.selected ? 'table-success' : '') + ' cursor-pointer'}
                onClick={() => this.props.toggleItemRow(this.state.item, 'statements')}
            >
                <td>{this.state.item.companyName}</td>
                <td>{this.state.item.day}</td>
                <td style={sumStyle}>{new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.item.sum)} {this.state.item.currency}</td>
                <td>{this.state.item.announcement ? this.state.item.announcement : '-'}</td>
            </tr>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/bank/steps/pairing/BankItemRow.js